import { Controller } from "@hotwired/stimulus";
import TomSelect from "tom-select";

export default class extends Controller {
  connect() {
    this.select = new TomSelect(this.element, {
      plugins: {
        remove_button: { title: "Fjern" },
      },
      persist: false,
      create: false,
      placeholder: this.element.dataset.placeholder,
    });

    this.element.classList.remove("form-control");
  }

  disconnect() {
    this.select?.destroy();
  }
}
